import { render, staticRenderFns } from "./movies-add-or-update.vue?vue&type=template&id=24ea398e"
import script from "./movies-add-or-update.vue?vue&type=script&lang=js"
export * from "./movies-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports